import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { toast } from "sonner";

export const InvoiceMenuItem = ({ selectedRowData, invoiceList, setInviteList, inviteList }) => {

  const handleSelectInvoice = (productID) => {
    const selectedInvoice = invoiceList?.find((invoice) => invoice?.product?.productID === productID);

    const availableSeats  = selectedInvoice?.product?.quantity - selectedInvoice?.product?.usedQuantity;
    const isAssignable = availableSeats - (
      (inviteList?.selectedInvoiceSeats?.[selectedInvoice?.product?.productID]?.[selectedInvoice?.invoiceKey] || 0)
    );

    if(isAssignable<=0){
      toast.error("This invoice doesn't have enough seat");
      return;
    }

    setInviteList((prev) => {
        const updatedSeats = { ...prev.selectedInvoiceSeats };

        if (updatedSeats[productID]) {
            if (updatedSeats[productID][selectedInvoice?.invoiceKey]) {
              updatedSeats[productID][selectedInvoice?.invoiceKey] += 1;
            } else {
              updatedSeats[productID][selectedInvoice?.invoiceKey] = 1;
            }
        } else {
            updatedSeats[productID] = {
              [selectedInvoice?.invoiceKey]: 1
            };
        }

      return {
        ...prev,
        data: prev?.data?.map((item) => {
            if (item?._id === selectedRowData?._id) {
            return {
                ...item,
                productID,
            };
            }
            return item;
        }),
        selectedInvoiceSeats : updatedSeats
      }
    });
  };

  return (
    <FormControl fullWidth variant="standard">
      <Select
        value={selectedRowData?.productID || ""}
        onChange={(event) => handleSelectInvoice(event.target.value)}
        sx={{ border: 0 }}
        displayEmpty
        renderValue={(val) => {
          const selectedInvoice = invoiceList?.find((invoice) => invoice?.product?.productID === val);
          return selectedInvoice ? <em>{selectedInvoice?.name}</em> : <em>Select Invoice</em>;
        }}
      >
        <MenuItem value="" disabled>
          <em>Select Invoice</em>
        </MenuItem>
        {invoiceList?.map((item, index) => (
          <MenuItem key={index} value={item?.product?.productID}>
            {item?.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
